import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiCpu, FiSmartphone, FiMonitor, FiSettings, FiMessageSquare, FiShield, FiZap, FiLayout, FiEye, FiEyeOff, FiActivity, FiClock, FiExternalLink, FiSave, FiAlertTriangle, FiCheckCircle, FiChevronRight, FiMaximize2, FiGlobe } = FiIcons;
import { mockApps, mockClients, mockVaultSecrets } from '../data/mockData';

const AIAssistant = () => {
  const [selectedAppId, setSelectedAppId] = useState('app_1');
  const [isSaving, setIsSaving] = useState(false);
  const [configs, setConfigs] = useState({
    app_1: {
      enabled: true,
      showDesktop: true,
      showMobile: false,
      provider: 'OpenAI',
      model: 'gpt-4o',
      vaultKeyRef: 'v_sec_2',
      welcomeMessage: 'Hello! I am the BPA Assistant. How can I help you today?',
      systemPrompt: 'You are a helpful assistant for BPA Solutions. You help users navigate the gateway and answer questions about email deliverability.',
      allowedPages: '*,/dashboard,/pricing',
      position: 'bottom-right',
      brandColor: '#2563eb',
      dailyLimit: 100,
      monthlyTokens: 250000,
      fallbackMessage: 'I am currently having trouble connecting. Please try again later.',
      status: 'active',
      lastUpdated: '2 hours ago'
    }
  });

  const currentApp = mockApps.find(a => a.id === selectedAppId) || mockApps[0];
  const currentConfig = configs[selectedAppId] || { enabled: false, provider: 'OpenAI', status: 'draft', lastUpdated: 'Never' };

  const updateConfig = (field, value) => {
    setConfigs({ ...configs, [selectedAppId]: { ...currentConfig, [field]: value } });
  };

  return (
    <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500 pb-12">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-3">
            <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-3">
              <SafeIcon icon={FiCpu} className="text-blue-600" /> AI Assistant Management
            </h2>
            <span className="px-2 py-0.5 bg-slate-100 text-slate-500 text-[10px] font-black uppercase rounded-md border border-slate-200">Placeholder module</span>
          </div>
          <p className="text-sm text-slate-500">Configure LLM-powered chatbots and classify incoming requests.</p>
        </div>
        <div className="flex gap-3">
          <select className="px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-medium outline-none focus:ring-2 focus:ring-blue-100 shadow-sm" value={selectedAppId} onChange={(e) => setSelectedAppId(e.target.value)} >
            {mockApps.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          <button onClick={() => alert('Feature in development')} className="px-6 py-2.5 bg-blue-600 text-white text-sm font-bold rounded-xl hover:bg-blue-700 transition-all shadow-md flex items-center gap-2" >
            <SafeIcon icon={FiSave} /> Save AI Config
          </button>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center">
        <SafeIcon icon={FiCpu} className="text-4xl text-slate-200 mx-auto mb-3" />
        <p className="text-slate-500 text-sm italic">AI Assistant integration is currently in the design phase and uses mock configuration for UI testing.</p>
      </div>
    </div>
  );
};

export default AIAssistant;